import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

// Create or update user document when they sign up/login
export const createOrUpdateUser = async (user) => {
  try {
    const userRef = doc(db, 'users', user.uid);
    const userDoc = await getDoc(userRef);
    
    const userData = {
      email: user.email,
      displayName: user.displayName || user.email,
      photoURL: user.photoURL || null,
      lastLogin: new Date(),
      updatedAt: new Date()
    };

    if (!userDoc.exists()) {
      // Create new user document
      await setDoc(userRef, {
        ...userData,
        createdAt: new Date()
      });
      console.log('Created new user document for:', user.email);
    } else {
      // Update existing user document
      await setDoc(userRef, userData, { merge: true });
      console.log('Updated user document for:', user.email);
    }
    
    return userData;
  } catch (error) {
    console.error('Error creating/updating user:', error);
    throw error;
  }
};
